export default __webpack_public_path__ + "static/media/usersIcon.53f71076.svg";